export default {
    perspectivesList: [],
    selectedPerspective: {},
    draftSelectedPerspective: {},
    perspectiveDirty: false,
    perspectiveId: "",
    searchPerspectiveData: {}
};
